import { render, staticRenderFns } from "./DataShowOff.vue?vue&type=template&id=14dd514c&scoped=true"
import script from "./DataShowOff.vue?vue&type=script&lang=js"
export * from "./DataShowOff.vue?vue&type=script&lang=js"
import style0 from "./DataShowOff.vue?vue&type=style&index=0&id=14dd514c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd514c",
  null
  
)

export default component.exports